<script>
    import History from '@js/modules/history';

    import BuildMap from '@js/components/maps/BuildMap.svelte';

    let initialMarkerPosition;

    const LOCATION_HISTORY_NAME = 'home_location_data';

    const initialLocationData = History.getPreviousState(LOCATION_HISTORY_NAME, {useUrlParams: true});

    if (initialLocationData && (initialLocationData.query || initialLocationData.value || initialLocationData.marker)) {
        const lat = parseFloat(initialLocationData.lat || (initialLocationData.center && initialLocationData.center[1]));
        const lng = parseFloat(initialLocationData.lng || (initialLocationData.center && initialLocationData.center[0]));

        if (lat && lng) {
            initialMarkerPosition = [lat, lng];
        }
    }
</script>

<div class="main-section home-map">
    <BuildMap mapId="home-map"
              initialMarkerPosition={initialMarkerPosition}/>
</div>
